import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=a64b95fa&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
import style0 from "./Chip.vue?vue&type=style&index=0&id=a64b95fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64b95fa",
  null
  
)

export default component.exports